/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Error_ApproveInputs */

const vi_sl_detail_error_approve = /** @type {(inputs: Sl_Detail_Error_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lỗi duyệt phiếu`)
};

/**

* @param {Sl_Detail_Error_ApproveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_error_approve = /** @type {((inputs?: Sl_Detail_Error_ApproveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Error_ApproveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_error_approve(inputs)
});